import { render } from "./radio-pc.vue?vue&type=template&id=37aa9c8a&ts=true"
import script from "./radio-pc.vue?vue&type=script&lang=ts"
export * from "./radio-pc.vue?vue&type=script&lang=ts"

import "./radio-pc.vue?vue&type=style&index=0&id=37aa9c8a&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__